import { fromJS } from 'immutable';
import {
  GET_CRS_CLUSTER_INFORMATION,
  GET_CRS_CLUSTER_INFORMATION_FAIL,
  GET_CRS_CLUSTER_INFORMATION_SUCCESS,
  GET_CRS_FEATURE_CATEGORY_FAIL,
  GET_CRS_FEATURE_CATEGORY_SUCCESS,
  GET_CRS_FEATURE_CATEGORY_CODES,
  GET_CRS_FEATURE_CODES,
  GET_CRS_FEATURE_CODES_FAIL,
  GET_CRS_FEATURE_CODES_SUCCESS,
  GET_CRS_TRANSACTION_PRODUCT_MAPPING,
  GET_CRS_TRANSACTION_PRODUCT_MAPPING_FAIL,
  GET_CRS_TRANSACTION_PRODUCT_MAPPING_SUCCESS,
  GET_CRS_TRANSACTION_TYPES,
  GET_CRS_TRANSACTION_TYPES_FAIL,
  GET_CRS_TRANSACTION_TYPES_SUCCESS,
  GET_CUSTOMER_PROFILE,
  GET_CUSTOMER_PROFILE_FAIL,
  GET_CUSTOMER_PROFILE_SUCCESS,
  GET_ASSOCIATED_CUSTOMERS,
  GET_ASSOCIATED_CUSTOMERS_FAIL,
  GET_ASSOCIATED_CUSTOMERS_SUCCESS,
  GET_CRS_HIST_ALERT_FAIL,
  GET_CRS_HIST_ALERT_SUCCESS,
  GET_CRS_HIST_ALERT,
  GET_CRS_TRANSACTION,
  GET_CRS_TRANSACTION_SUCCESS,
  GET_CRS_TRANSACTION_FAIL,
  GET_CRS_RISK_INDICATOR,
  GET_CRS_RISK_INDICATOR_SUCCESS,
  GET_CRS_RISK_INDICATOR_FAIL,
  GET_CRS_RISK_INDICATOR_GRAPH,
  GET_CRS_RISK_INDICATOR_GRAPH_SUCCESS,
  GET_CRS_RISK_INDICATOR_GRAPH_FAIL,
  GET_CRS_MODEL_EXPLAINABILITY_DATA_FAIL,
  GET_CRS_MODEL_EXPLAINABILITY_DATA_SUCCESS,
  GET_CRS_MODEL_EXPLAINABILITY_DATA,
  GET_CRS_MODEL_EXPLAINABILITY_STATS_FAIL,
  GET_CRS_MODEL_EXPLAINABILITY_STATS_SUCCESS,
  GET_CRS_MODEL_EXPLAINABILITY_STATS,
  GET_CRS_TREND_ANALYSIS_DATA,
  GET_CRS_TREND_ANALYSIS_DATA_FAIL,
  GET_CRS_TREND_ANALYSIS_DATA_SUCCESS,
  GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA,
  GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_SUCCESS,
  GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_FAIL,
  UPDATE_CRS_RISK_SCORE_HISTORY,
  UPDATE_CRS_RISK_SCORE_HISTORY_SUCCESS,
  UPDATE_CRS_RISK_SCORE_HISTORY_FAIL,
  PUT_RISK_SCORE_ACCEPTANCE,
  PUT_RISK_SCORE_ACCEPTANCE_SUCCESS,
  PUT_RISK_SCORE_ACCEPTANCE_FAIL,
  GET_CRS_RISK_SCORE_HISTORY,
  GET_CRS_RISK_SCORE_HISTORY_SUCCESS,
  GET_CRS_RISK_SCORE_HISTORY_FAIL
} from '../../actions/crs/crsRiskDetail';

const initialState = fromJS({
  customerProfileResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  associatedCustomersResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  clusterInformationResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  crsFeatureCodesResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  crsTransactionTypesResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  crsFeatureCategoryCodesResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  crsTransactionProductionMappingResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  alertHistoryResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  transactionHistoryResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  riskIndicatorsResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  riskIndicatorsGraphResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  modelExplainAbilityResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  trendAnalysisResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  clusterViewDescriptionResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  updateRiskScoreHistoryResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  acceptRiskScoreResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },

  getRiskScoreHistoryResponse: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  }
});

function crsRiskDetailReducer(state = initialState, action) {
  switch (action.type) {
    /**
     * CUSTOMER PROFILE START
     * */
    case GET_CUSTOMER_PROFILE:
      return {
        ...state,
        customerProfileResponse: {
          isFetching: true,
          fetched: false,
          ...action.payload
        }
      };
    case GET_CUSTOMER_PROFILE_SUCCESS:
      return {
        ...state,
        customerProfileResponse: {
          isFetching: false,
          fetched: true,
          ...action.payload
        }
      };
    case GET_CUSTOMER_PROFILE_FAIL:
      return {
        ...state,
        customerProfileResponse: {
          isFetching: false,
          fetched: false,
          ...action.payload
        }
      };

    /**
     * CUSTOMER PROFILE END
     * */

    /**
     * ASSOCIATED CUSTOMERS START
     * */
    case GET_ASSOCIATED_CUSTOMERS:
      return {
        ...state,
        associatedCustomersResponse: {
          isFetching: true,
          fetched: false,
          ...action.payload
        }
      };
    case GET_ASSOCIATED_CUSTOMERS_SUCCESS:
      return {
        ...state,
        associatedCustomersResponse: {
          isFetching: false,
          fetched: true,
          ...action.payload
        }
      };
    case GET_ASSOCIATED_CUSTOMERS_FAIL:
      return {
        ...state,
        associatedCustomersResponse: {
          isFetching: false,
          fetched: false,
          ...action.payload
        }
      };
    /**
     * ASSOCIATED CUSTOMERS END
     * */

    /**
     * CLUSTER INFORMATION START
     * */

    case GET_CRS_CLUSTER_INFORMATION:
      return {
        ...state,
        clusterInformationResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_CLUSTER_INFORMATION_SUCCESS:
      return {
        ...state,
        clusterInformationResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_CLUSTER_INFORMATION_FAIL:
      return {
        ...state,
        clusterInformationResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     * CLUSTER INFORMATION END
     * */

    /**
     * CRS FEATURE CODES START
     * */

    case GET_CRS_FEATURE_CODES:
      return {
        ...state,
        crsFeatureCodesResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_FEATURE_CODES_SUCCESS:
      return {
        ...state,
        crsFeatureCodesResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_FEATURE_CODES_FAIL:
      return {
        ...state,
        crsFeatureCodesResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     * CRS FEATURE CODES END
     * */

    /**
     * CRS TRANSACTION TYPES START
     * */

    case GET_CRS_TRANSACTION_TYPES:
      return {
        ...state,
        crsTransactionTypesResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_TRANSACTION_TYPES_SUCCESS:
      return {
        ...state,
        crsTransactionTypesResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_TRANSACTION_TYPES_FAIL:
      return {
        ...state,
        crsTransactionTypesResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     * CRS TRANSACTION TYPES END
     * */

    /**
     * CRS FEATURE CATEGORY TYPES START
     * */

    case GET_CRS_FEATURE_CATEGORY_CODES:
      return {
        ...state,
        crsFeatureCategoryCodesResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_FEATURE_CATEGORY_SUCCESS:
      return {
        ...state,
        crsFeatureCategoryCodesResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_FEATURE_CATEGORY_FAIL:
      return {
        ...state,
        crsFeatureCategoryCodesResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     * CRS FEATURE CATEGORY TYPES END
     * */

    /**
     * CRS TRANSACTION PRODUCT MAPPING START
     * */

    case GET_CRS_TRANSACTION_PRODUCT_MAPPING:
      return {
        ...state,
        crsTransactionProductionMappingResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_TRANSACTION_PRODUCT_MAPPING_SUCCESS:
      return {
        ...state,
        crsTransactionProductionMappingResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_TRANSACTION_PRODUCT_MAPPING_FAIL:
      return {
        ...state,
        crsTransactionProductionMappingResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     * CRS TRANSACTION PRODUCT MAPPING END
     * */

    /** ALERT HISTORY START **/
    case GET_CRS_HIST_ALERT:
      return {
        ...state,
        alertHistoryResponse: {
          ...state.alertHistoryResponse,
          isFetching: true,
          fetched: false,
          ...action.payload
        }
      };
    case GET_CRS_HIST_ALERT_SUCCESS:
      if (action.payload.isScrolled) {
        const {
          alertHistoryResponse: { alert_list }
        } = state;
        return {
          ...state,
          alertHistoryResponse: {
            isFetching: false,
            fetched: true,
            alert_list: alert_list.concat(action.payload.alert_list),
            hasMore:
              Array.isArray(action.payload.alert_list) &&
              action.payload.alert_list.length >= 10
          }
        };
      }

      return {
        ...state,
        alertHistoryResponse: {
          isFetching: false,
          fetched: true,
          hasMore:
            Array.isArray(action.payload.alert_list) &&
            action.payload.alert_list.length >= 10,
          ...action.payload
        }
      };
    case GET_CRS_HIST_ALERT_FAIL:
      return {
        ...state,
        alertHistoryResponse: {
          isFetching: false,
          fetched: false,
          ...action.payload
        }
      };
    /** ALERT HISTORY END **/

    /** TRANSACTION HISTORY START***/
    case GET_CRS_TRANSACTION:
      return {
        ...state,
        transactionHistoryResponse: {
          ...state.transactionHistoryResponse,
          isFetching: true,
          fetched: false
        }
      };
    case GET_CRS_TRANSACTION_SUCCESS:
      return {
        ...state,
        transactionHistoryResponse: {
          isFetching: false,
          fetched: true,
          data: {
            ...action.payload,
            hasMore:
              Array.isArray(action.payload.associated_transactions) &&
              action.payload.associated_transactions.length >= 10
          },
          error: null
        }
      };
    case GET_CRS_TRANSACTION_FAIL:
      return {
        ...state,
        transactionHistoryResponse: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };
    /** TRANSACTION HISTORY END***/

    /*** RISK INDICATOR START **/
    case GET_CRS_RISK_INDICATOR:
      return {
        ...state,
        riskIndicatorsResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_RISK_INDICATOR_SUCCESS:
      return {
        ...state,
        riskIndicatorsResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_RISK_INDICATOR_FAIL:
      return {
        ...state,
        riskIndicatorsResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     * RISK INDICATOR END
     * */

    /*** RISK INDICATOR GRAPH START **/
    case GET_CRS_RISK_INDICATOR_GRAPH:
      return {
        ...state,
        riskIndicatorsGraphResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_RISK_INDICATOR_GRAPH_SUCCESS:
      return {
        ...state,
        riskIndicatorsGraphResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_RISK_INDICATOR_GRAPH_FAIL:
      return {
        ...state,
        riskIndicatorsGraphResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     * RISK INDICATOR GRAPH END
     * */

    /*** MODEL EXPLAINABILITY START **/

    case GET_CRS_MODEL_EXPLAINABILITY_DATA:
      return {
        ...state,
        modelExplainAbilityResponse: {
          isFetching: true,
          fetched: false,
          ...action.payload
        }
      };
    case GET_CRS_MODEL_EXPLAINABILITY_DATA_SUCCESS:
      return {
        ...state,
        modelExplainAbilityResponse: {
          isFetching: false,
          fetched: true,
          ...action.payload
        }
      };
    case GET_CRS_MODEL_EXPLAINABILITY_DATA_FAIL:
      return {
        ...state,
        modelExplainAbilityResponse: {
          isFetching: false,
          fetched: false,
          ...action.payload
        }
      };
    case GET_CRS_MODEL_EXPLAINABILITY_STATS:
      return {
        ...state,
        modelExplainAbilityStatsResponse: {
          isFetching: true,
          fetched: false,
          ...action.payload
        }
      };
    case GET_CRS_MODEL_EXPLAINABILITY_STATS_SUCCESS:
      return {
        ...state,
        modelExplainAbilityStatsResponse: {
          isFetching: false,
          fetched: true,
          ...action.payload
        }
      };
    case GET_CRS_MODEL_EXPLAINABILITY_STATS_FAIL:
      return {
        ...state,
        modelExplainAbilityStatsResponse: {
          isFetching: false,
          fetched: false,
          ...action.payload
        }
      };
    /**
     * MODEL EXPLAINABILITY END
     * */

    /*** TREND ANALYSIS START **/

    case GET_CRS_TREND_ANALYSIS_DATA:
      return {
        ...state,
        trendAnalysisResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        },
        clusterInformationResponse: {
          isFetching: false,
          fetched: true,
          data: {}
        }
      };
    case GET_CRS_TREND_ANALYSIS_DATA_SUCCESS:
      return {
        ...state,
        trendAnalysisResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_TREND_ANALYSIS_DATA_FAIL:
      return {
        ...state,
        trendAnalysisResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     *  TREND ANALYSIS END
     * */

    /*** ClusterView Description START **/

    case GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA:
      return {
        ...state,
        clusterViewDescriptionResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_SUCCESS:
      return {
        ...state,
        clusterViewDescriptionResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_FAIL:
      return {
        ...state,
        clusterViewDescriptionResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     *  ClusterView Description END
     * */

    /*** Update Risk Score History START **/

    case UPDATE_CRS_RISK_SCORE_HISTORY:
      return {
        ...state,
        updateRiskScoreHistoryResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case UPDATE_CRS_RISK_SCORE_HISTORY_SUCCESS:
      return {
        ...state,
        updateRiskScoreHistoryResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case UPDATE_CRS_RISK_SCORE_HISTORY_FAIL:
      return {
        ...state,
        updateRiskScoreHistoryResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     *  Update Risk Score History END
     * */

    /*** Get Risk Score History START **/

    case GET_CRS_RISK_SCORE_HISTORY:
      return {
        ...state,
        getRiskScoreHistoryResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CRS_RISK_SCORE_HISTORY_SUCCESS:
      return {
        ...state,
        getRiskScoreHistoryResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CRS_RISK_SCORE_HISTORY_FAIL:
      return {
        ...state,
        getRiskScoreHistoryResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     *  Get Risk Score History END
     * */

    /*** Accept Risk Score START **/

    case PUT_RISK_SCORE_ACCEPTANCE:
      return {
        ...state,
        acceptRiskScoreResponse: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case PUT_RISK_SCORE_ACCEPTANCE_SUCCESS:
      return {
        ...state,
        acceptRiskScoreResponse: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case PUT_RISK_SCORE_ACCEPTANCE_FAIL:
      return {
        ...state,
        acceptRiskScoreResponse: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };
    /**
     *  Accept Risk Score END
     * */

    default:
      return state;
  }
}

export default crsRiskDetailReducer;
